<template>
  <a :href="url" target="_blank" class="download" :aria-label="`Download file: ${title}`">
      <div class="download__icon">
        <div class="icon icon--download" aria-hidden="true">
          <download-svg></download-svg>
        </div>
      </div>
      <div class="download__content">
        <p class="download__name">
          <span>{{ title }}</span>
        </p>
        <p class="is-small has-text-grey-dark download__category">
          {{ type }}
        </p>
        <p class="is-small has-text-grey-dark download__filesize">
          {{ size }}
        </p>
        <p class="is-small has-text-grey-dark download__filetype">
          {{ format }}
        </p>
      </div>
    </a>
</template>

<script>
import DownloadSvg from '@/components/svg/download.vue';

export default {
  name: 'download',
  components: { DownloadSvg },
  props: ['title', 'url', 'type', 'size', 'format'],
};
</script>
